import { arrayToMap } from 'nucleus-widgets/utils/arrayToMap';

/*
 * Transforms the snapshot to make it easier to work with in the application.
 */
export default function transformAccountSnapshot(accountSnapshot) {
  return {
    ...accountSnapshot,
    contactCustomFields: arrayToMap(accountSnapshot.contactCustomFields, customField => customField.question.id)
  };
}
